import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Star, Check } from "lucide-react";
import { api, errText } from "../../lib/admin";
import { reviewText, toIntl } from "../../lib/review";

const yesterday = () => { const d = new Date(); d.setDate(d.getDate() - 1); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`; };

export const ReviewsPanel = () => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    const y = yesterday();
    api.get("/admin/appointments")
      .then((r) => setItems((Array.isArray(r.data) ? r.data : []).filter((a) => a.status === "confirmed" && a.preferred_date === y)
        .sort((a, b) => (a.confirmed_time || "99").localeCompare(b.confirmed_time || "99"))))
      .catch((e) => { toast.error(errText(e)); setItems([]); });
  }, []);
  const mark = (a) => {
    setItems((xs) => xs.map((x) => (x.id === a.id ? { ...x, review_requested: true } : x)));
    api.patch(`/admin/appointments/${a.id}`, { review_requested: true }).catch(() => {});
  };
  if (!items) return null;
  return (
    <section className="bg-white border border-[#e7dfd3] rounded-2xl p-6" data-testid="reviews-panel">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="flex items-center gap-2 text-[0.7rem] tracking-[0.18em] uppercase text-[#8A6A3A]"><Star className="w-4 h-4" /> Clienti di ieri · chiedi una recensione</p>
        <p className="text-xs text-[#6b625a]">Si apre WhatsApp con il messaggio e il link a Google</p>
      </div>
      {items.length === 0 ? <p className="mt-4 text-[#6b625a]" data-testid="reviews-empty">Nessun appuntamento confermato ieri.</p> : (
        <ul className="mt-4 divide-y divide-[#efe9df]">
          {items.map((a) => {
            const phone = toIntl(a.phone);
            return (
              <li key={a.id} className="py-3 flex flex-wrap items-center gap-3" data-testid={`review-row-${a.id}`}>
                <span className="font-stencil tracking-[0.12em] text-[#8A6A3A] w-14">{a.confirmed_time || "—"}</span>
                <span className="min-w-0 flex-1">
                  <span className="block text-[#14110F]">{a.name}</span>
                  <span className="block text-xs text-[#6b625a]">{a.service}</span>
                </span>
                {phone ? (
                  <a href={`https://wa.me/${phone}?text=${encodeURIComponent(reviewText(a.name.split(" ")[0], a.service))}`} target="_blank" rel="noreferrer" onClick={() => mark(a)} data-testid={`review-ask-${a.id}`}
                    className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-[0.7rem] tracking-[0.14em] uppercase transition-colors duration-200 ${a.review_requested ? "border border-[#b9d8bf] text-[#2f6b3d]" : "bg-[#14110F] text-[#F6F2EC] hover:bg-[#8A6A3A]"}`}>
                    {a.review_requested ? <Check className="w-4 h-4" /> : <Star className="w-4 h-4" />} {a.review_requested ? "Richiesta inviata" : "Chiedi recensione"}
                  </a>
                ) : <span className="text-xs text-[#9b9188]">Numero non valido</span>}
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
};
